import type {
  MoneyInput,
  SubmitFlexPayOverTimeOnboardingPaymentPlan,
} from '@varo/graphql-schema-types';
import { atom } from 'jotai';

interface PayLaterSetUp {
  paymentPlan: SubmitFlexPayOverTimeOnboardingPaymentPlan;
  purchaseAmount: MoneyInput;
}

export const payLaterSetUpAtom = atom<PayLaterSetUp | null>(null);
